/**
 * contiene la información para el manejo de las graficas.
 */
export const defaultGraficas = () => {
    return {
        productos: '',
        conSga: '',
        sinSga: '',
        conUn: '',
        sinUn: '',
        /*  conHmis: '',
         sinHmis: '', */
        conNfpa: '',
        sinNfpa: '',


        cambia: false
    }
}

/**
 * contiene la información para el manejo de las graficas.
 */
export const defaultGraficasFdsMsds = () => {
    return {
        productos: '',

        conFDS: '',
        conMSDS: '',
        sinAdj: '',

        porc_con_FDS: '',
        porc_con_MSDS: '',
        porc_sin_Adj: '',

        cambia: false
    }
}

/**
 * Contiene las notificaciones.
 *
 * @returns {array} Contiene las notificaciones no leidas.
 * @author Brandon Torres
 */
export const defaultNotifications = () => {
    if (JSON.parse(localStorage.getItem('notifylocalStorage')) != null) {
        return JSON.parse(localStorage.getItem('notifylocalStorage'));
    } else {
        return [];
    }
}

export default {
    loading: true,
    controlAccesos: true,
    usuario: '',
    cargando_datos_select: false,
    filtro: {
        empresa: ""
    },
    //graficas
    selectedGraficas: defaultGraficas(),
    selectedGraficasFdsMsds: defaultGraficasFdsMsds(),
    notifications: defaultNotifications(),
    tabActiveCompany: 0,

    //dashboard
    dataDash1: {
        total_inventory: 0,
        total_inventory_verified: 0,
        total_inventory_for_verification: 0,
        not_use: 0,
        used: 0,
        not_document: 0,
        not_comply: 0,
        comply: 0,
        attachment_with_revision: 0,
        attachment_not_revision: 0,
        certificate_not_risk: 0,
        fds_not_spain: 0,
        msds: 0,
        sga_physical_total: 0,
        sga_health_total: 0,
        sga_environment_total: 0,
        product_company_ids: [],
        consulted: false,
        total_tanks:0,
        classified_facilities:0,
        total_benefits:0,
        benefirs_for_years:[],
        priority:{
            priority_1: 0,
            priority_2: 0,
            priority_3: 0,
            total: 0
        }
    },
    dataDash2: {
        oral_category_1_count: 0,
        products_oral_category_1: [],
        oral_category_2_count: 0,
        products_oral_category_2: [],
        inhalation_category_1_count: 0,
        products_inhalation_category_1: [],
        inhalation_category_2_count: 0,
        products_inhalation_category_2: [],
        cutaneous_category_1_count: 0,
        products_cutaneous_category_1: [],
        cutaneous_category_2_count: 0,
        products_cutaneous_category_2: [],
        carcinogenic_group_1_count: 0,
        carcinogenic_group_2A_count: 0,
        carcinogenic_group_2B_count: 0,
        carcinogenic_reported_by_sds_count: 0,
        carcinogenic_group_1_products: [],
        carcinogenic_group_2A_products: [],
        carcinogenic_group_2B_products: [],
        carcinogenic_reported_by_sds_products: [],
        components_priority_normative: [],
        consulted: false,
        product_reprotoxic_count: 0,
        product_reprotoxic_with_affected_count: 0,
        product_reprotoxic_not_affected_count: 0,
        product_ototoxic_count: 0,
        product_ototoxic_with_affected_count: 0,
        product_ototoxic_not_affected_count: 0,
        product_mutagenic_count: 0,
        product_mutagenic_with_affected_count: 0,
        product_mutagenic_not_affected_count: 0,
        total_sga_aspiration_hazard_count: 0,
        total_sga_irritants_dermal_count: 0,
        total_sga_corrosive_dermal_count: 0,
        categories_health: [],
        product_corrosive_ocular_count: 0,
        product_corrosive_dermal_count: 0,
        product_corrosive_total: 0,
        product_neurotoxic_count: 0,
        levels_neurotoxic: {
            level_1: 0,
            level_2: 0,
            level_3: 0,
            level_4: 0,
            level_for_sga: 0
        },
        sga_sensitizing_dermal_count: 0,
        sga_sensitizing_respiratory_count: 0,
        product_target_organs_count: 0,
        product_reproductive_organs_count: 0,
        product_not_danger_count: 0,
        total_inventory_verified: 0,
        total_death: 0
    },


    //screens
    screens: {
        accident: true,
        health: false,
        general: false,
    },

    //products dash affected
    productsDashAffected: [],

    //filters
    dashboardFilters: {
        company_id: null,
        slq_location_id: null,
        date_report: null,
        in_use: null,
    }
}

export const sanitizarString = (texto) => {
    texto = texto.trim();

    texto = texto.replace(/ /g, '-');
    texto = texto.toLocaleLowerCase();

    texto = texto.replace(/[áàäâªÁÀÂÄ]/g, 'a');
    texto = texto.replace(/[éèëêÉÈÊË]/g, 'e');
    texto = texto.replace(/[íìïîÍÌÏÎ]/g, 'i');
    texto = texto.replace(/[óòöôõÓÒÖÔ]/g, 'o');
    texto = texto.replace(/[úùüûÚÙÛÜ]/g, 'u');

    texto = texto.replace(/[ñÑ]/g, 'n');
    texto = texto.replace(/[çÇ]/g, 'c');

    texto = texto.replace(/[\\¨º~*#@|!\,·$%&/()?'¡¿[^<>+}{¨´><;:.\]]/g, '');
    texto = texto.replace(/--/g, '-');

    return texto;
};


